import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';

const propTypes = {
    skin: deprecatedProp(PropTypes.oneOf([
        'standard',
        'searchbar'
    ]), 'No need to provide any skin. Simply use an Icon in button'),
    buttonPosition: PropTypes.oneOf([
        'left',
        'right'
    ])
};
const TextInputWithButtonInset = createComponent({
    displayName: 'TextInputWithButtonInset',
    root: 'div',
    propTypes,
    propConfig: {
        classNames (props) {
            const classesSet = new Set([
                'swan-vanilla-ignore',
                'swan-input-with-button-inset'
            ]);
            if (props.buttonPosition && props.buttonPosition === 'left') classesSet.add(`swan-input-with-button-left`);
            if (props.skin && props.skin !== 'standard') classesSet.add(`swan-input-with-button-skin-${props.skin}`);
            return classesSet;
        }
    }
});

export { TextInputWithButtonInset };
